export default "__VITE_ASSET__482a2b22__"